export const environment = {
    production: true,
    baseUrl: 'https://brokerplus.higift.com/api/v1',
    defaultLang: 'en',
    clientId: '335951033022-ui3350pk8nrg6c37djk6o6niqukquimb.apps.googleusercontent.com',
    appleClientId: '8PGHC5CVK8.com.higift.shop',
    userAccountBaseUrl: 'https://apiaccount.avainfo.tech/api/v1'
};
